import allCountries from './raws/allCountries.json';
import currencies from './raws/currencies.json';
import countryPriorityMap from './raws/countryPriorityMap.json';

class Countries {
  static anyCountyPlaceHolder() {
    return {
      countryCode: '',
      countryCodeLowerCase: '',
      countryName: 'Tous les pays',
      callingCode: 0,
      region: '',
      Supported: false,
      chooseAsDepositCountry: false,
      currency: ''
    };
  }
  static find(countryCode = '') {
    return countriesJson[countryCode.toUpperCase()] || null;
  }
  static getByCountryCode(countryCodes) {
    let countries = countryCodes
      .map((countryCode) => {
        return countriesJson[countryCode];
      })
      .filter((country) => !!country);
    return countries;
  }
  static getPhoneCountry(phoneNumber) {
    if (!phoneNumber) return null;
    let callingCode = phoneNumber.replace(/^(...).+$/, '$1');
    let country = Countries.get().find(
      (countryTested) => countryTested.callingCode == callingCode
    );
    if (!country) {
      callingCode = phoneNumber.replace(/^(..).+$/, '$1');
      country = Countries.get().find(
        (countryTested) => countryTested.callingCode == callingCode
      );
    }
    return country;
  }
  static get() {
    return countriesArray;
  }

  static getCurrencies(codes, withFlag) {
    let allCurrencies = currencies;
    if (withFlag) allCurrencies = Countries.getCurrenciesWithFlags();
    if (codes && Array.isArray(codes)) {
      const upperCaseCodes = codes
        .filter((value) => !!value && typeof value == 'string')
        .map((code) => code.toUpperCase());
      return allCurrencies.filter((currency) =>
        upperCaseCodes.includes(currency.code.toUpperCase())
      );
    }
    return allCurrencies;
  }

  static generateCurrencyFlagMap() {
    const currencyToCountriesMap = {};

    // Create a mapping of currency to countries
    allCountries.forEach((country) => {
      if (country.currencies && country.currencies.length > 0) {
        country.currencies.forEach((currency) => {
          if (!currencyToCountriesMap[currency.code]) {
            currencyToCountriesMap[currency.code] = [];
          }
          currencyToCountriesMap[currency.code].push({
            alpha2Code: country.alpha2Code,
            name: country.translations?.fr || country.name,
            priority: this.getCountryPriority(country.alpha2Code)
          });
        });
      }
    });

    // For each currency, select the best country (highest priority)
    const flagMap = {};
    Object.keys(currencyToCountriesMap).forEach((currencyCode) => {
      const countries = currencyToCountriesMap[currencyCode];
      // Sort by priority and select the first one
      countries.sort((a, b) => b.priority - a.priority);
      flagMap[currencyCode] = countries[0].alpha2Code.toLowerCase();
    });

    return flagMap;
  }

  static getCountryPriority(countryCode) {
    // Get priority from the imported JSON file
    return countryPriorityMap[countryCode] || 1; // Default priority
  }

  static getCurrencyFlagMap() {
    // Generate and cache the map if not already done
    if (!this._currencyFlagMap) {
      this._currencyFlagMap = this.generateCurrencyFlagMap();
    }
    return this._currencyFlagMap;
  }

  static getCurrencyFlagForCurrency(currencyCode) {
    const flagMap = this.getCurrencyFlagMap();
    return flagMap[currencyCode] || 'xx';
  }

  static getCurrenciesWithFlags() {
    return currencies.map((currency) => ({
      ...currency,
      flag: this.getCurrencyFlagForCurrency(currency.code)
    }));
  }
}

const signupCountries = 'BJ,BF,CI,ML,SN,TG'.split(',');
const ecowasCountries = [
  'BJ',
  'BF',
  'CI',
  /* "GW", */ 'ML',
  /* "NE", */ 'SN',
  'TG'
];

const waterAndElectricBill = ['BJ'];

function getCountriesArray() {
  return Object.values(countriesJson);
}

function getCountriesJson() {
  const countriesAsJson = {};

  allCountries.forEach((element) => {
    const country = {
      localLogoUrl:
        '/images/flags/' + element.alpha2Code.toLowerCase() + '.svg',
      countryCode: element.alpha2Code,
      countryCodeLowerCase: element.alpha2Code.toLowerCase(),
      countryName: element.translations.fr,
      name: element.translations.fr,
      callingCode: parseInt(element.callingCodes[0] || '0', 10),
      region: element.region,
      currency: element.currencies[0].code,
      phonePrefix: element.callingCodes[0]
    };
    countriesAsJson[country.countryCode] = country;
  });

  return countriesAsJson;
}

const countriesJson = getCountriesJson();
const countriesArray = getCountriesArray();

export { Countries };
